module.exports = __webpack_public_path__ + "images/left.07fbce1406e030524f914470cf0beab2.png";